/**
 * The painter's cost line (AltarBuilder). Before the Community opens a
 * portrait repaint is free and no price shows at all (quest journey API v1
 * §6); a 4th repaint answers 409 repaint_later with the server's own words.
 */
export function paintCostLabel ({ freeRemaining = null, cost = null, balance = 0, pricesVisible = true } = {}) {
  if (!pricesVisible || freeRemaining === null || freeRemaining === undefined) return ''
  if (freeRemaining > 0) return `${freeRemaining} free left`
  return `${cost} carats each · balance ${balance} carats`
}

export function repaintLaterWords (err) {
  const r = err && err.response
  const d = r && r.data
  return r && r.status === 409 && d && d.error === 'repaint_later' ? (d.words || 'You can paint more once the Community opens.') : ''
}

/** A conjure past the free three before the Community (409 conjure_later): its words, no numbers. */
export function conjureLaterWords (err) {
  const r = err && err.response
  const d = r && r.data
  return r && r.status === 409 && d && d.error === 'conjure_later' ? (d.words || 'You can conjure more looks once the Community opens.') : ''
}

/** The Voice's paint button: no price before the Community (API v1.2). */
export function conjurePaintLabel (cost, { pricesVisible = true, format = (n) => String(n) } = {}) {
  return pricesVisible ? `Paint it - ${format(cost)}` : 'Paint it'
}
